import { useCallback, useEffect, useState } from 'react'

function useHtmlPrint() {
    const [loading, setLoading] = useState(false)
    const iframe = document.createElement('iframe')
    const [body, setBody] = useState<string>('')

    const handlePrint = useCallback(
        (html: string) => {
            setBody(html)
            setLoading(true)
            if (!html) return

            document.body.appendChild(iframe)
            iframe.style.display = 'none'
            iframe.srcdoc = html

            const cleanUp = () => {
                if (iframe.parentNode) {
                    document.body.removeChild(iframe)
                }
            }

            const handleWindowFocus = () => {
                cleanUp()
                window.removeEventListener('focus', handleWindowFocus)
            }

            iframe.onload = () => {
                iframe.contentWindow?.focus()
                iframe.contentWindow?.print()
                window.addEventListener('focus', handleWindowFocus)
            }

            setLoading(false)
        },
        [iframe]
    )

    usePrintKeyPress(handlePrint, body, loading)

    return {
        loading,
        handlePrint,
    }
}

const usePrintKeyPress = (handlePrint: (body: string) => void, body: string, loading: boolean) => {
    useEffect(() => {
        const handlePrintKeysPressed = (event: KeyboardEvent) => {
            if (event.key === 'p' && (event.ctrlKey || event.metaKey)) {
                event.preventDefault()
                if (loading) return

                handlePrint(body)
            }
        }

        document.addEventListener('keydown', handlePrintKeysPressed)

        return () => {
            document.removeEventListener('keydown', handlePrintKeysPressed)
        }
    }, [handlePrint, loading])
}

export default useHtmlPrint
